import {
  deleteTags,
  addTags as pushTags,
  selectTag,
  setTagNumber,
  unselectTag,
  updateTags,
} from "../../store/actions";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TagMap } from "../../types";
import { getTagName } from "../../utils";
import useDeepCompareEffect from "use-deep-compare-effect";

const useTags = () => {
  const tagsState: TagMap = useSelector((state: any) => state.tags);
  const [storedTags, setStoredTags] = useState<TagMap>(tagsState);
  const buildCategories = useCallback(() => {
    let cats: Set<string> = new Set();
    for (let id of Object.keys(storedTags)) {
      const { name, category } = getTagName(id);

      cats.add(category);
    }
    return Array.from(cats);
  }, [storedTags]);

  const [categories, setCategories] = useState<string[]>(buildCategories());
  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    setStoredTags(tagsState);
  }, [tagsState]);

  useDeepCompareEffect(() => {
    setCategories(buildCategories());
  }, [storedTags]);

  const addTags = (_tags: TagMap) => {
    dispatch(pushTags(_tags));
  };

  const refreshTags = (_tags: TagMap) => {
    dispatch(updateTags(_tags));
  };

  const setSelected = (id: string) => {
    dispatch(selectTag(id));
  };

  const setNumber = (id: string, number: number) => {
    dispatch(setTagNumber(id, number));
  };

  const setUnselected = (id: string) => {
    dispatch(unselectTag(id));
  };

  const removeTags = () => {
    dispatch(deleteTags());
  };

  return {
    categories,
    tags: storedTags,
    removeTags,
    addTags,
    setNumber,
    setSelected,
    setUnselected,
    refreshTags,
  };
};

export default useTags;
